import React from 'react';
import Skeleton from 'react-loading-skeleton';

type Props = {
    count?: number;
};

const CreditorPanelsSkeleton: React.FC<Props> = ({ count = 2 }) => {
    return (
        <>
            <fieldset className="sgw-checkbox-panels">
                <Skeleton style={{ marginBottom: 12 }} height={27} width={200} />

                <Skeleton style={{ marginBottom: 12 }} height={20} width={300} />
                {Array.from(Array(count)).map((_, index) => (
                    <Skeleton
                        style={{ marginBottom: 12 }}
                        className="creditor-skeleton__item"
                        // eslint-disable-next-line react/no-array-index-key
                        key={`creditor-skeleton-${index}`}
                        height={102}
                        width="100%"
                    />
                ))}
            </fieldset>
        </>
    );
};

export default CreditorPanelsSkeleton;
